<!-- ===== SERVICE DETAIL ===== -->
<div class="service-detail" *ngIf="ecomm > 0">

  <!-- Header -->
  <div class="sd-header">
    <div class="sd-breadcrumb">
      <span (click)="irr('home')">{{ t.breadcrumb_home }}</span>
      <span class="sep">→</span>
      <span class="current">{{ getCurrentTitle() }}</span>
    </div>

    <div class="sd-header-inner">
      <div class="sd-header-left">
        
        <h1 class="sd-title">{{ getCurrentTitle() }}</h1>
        <p class="sd-subtitle">{{ getCurrentSubtitle() }}</p>
      </div>
      <div class="sd-header-icon">
        
      </div>
    </div>

    <!-- Animated line 
    <div class="sd-line-animated">
      <div class="sd-star"></div>
    </div>-->
  </div>

  <!-- Intro text -->
  <div class="sd-intro">
    <p class="sd-intro-text">{{ getCurrentIntro() }}</p>
  </div>

  <!-- Feature list -->
  <div class="sd-features">
    <div class="sd-feature-item" *ngFor="let feature of getCurrentFeatures(); let i = index">
      <div class="sd-feature-num">0{{ i + 1 }}</div>
      <div class="sd-feature-content">
        <h3 class="sd-feature-title">{{ feature.title }}</h3>
        <p class="sd-feature-desc">{{ feature.desc }}</p>
      </div>
      <div class="sd-feature-divider"></div>
    </div>
  </div>

  <!-- FAQ -->
  <div class="sd-faq">
    <h2 class="sd-faq-title">{{ t.faq_title }}</h2>
    <div class="sd-faq-list">
      <div class="sd-faq-item" *ngFor="let f of getCurrentFaqs(); let i = index" [class.open]="openFaqIndex === i">
        <button class="sd-faq-question" (click)="toggleFaq(i)" [attr.aria-expanded]="openFaqIndex === i">
          <span>{{ f.question }}</span>
          <span class="sd-faq-icon" aria-hidden="true"></span>
        </button>
        <div class="sd-faq-answer" *ngIf="openFaqIndex === i">
          <p>{{ f.answer }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- CTA bottom -->
  <div class="sd-cta">
    <div class="sd-cta-text">
      <div class="sd-cta-label">{{ t.cta_label }}</div>
      <h2 class="sd-cta-title" [innerHTML]="t.cta_title"></h2>
    </div>
    <a href="mailto:hola@patagonia-chain.com" class="btn-primary">{{ t.cta_btn }}</a>
  </div>

</div>

<!-- ===== FOOTER ===== -->
<footer id="footer">
  <div class="footer-top">
    <div class="footer-brand">
      <div class="footer-brand-name">Patagonia Chain</div>
      <div class="footer-brand-sub">Rosario, Argentina — {{ t.footer_sub }}</div>
    </div>
    <div class="footer-links">
      <div class="footer-col">
        <div class="footer-col-title">{{ t.footer_nav }}</div>
        <ul>
          <li><a (click)="goHome('quienes')">{{ t.nav_quienes }}</a></li>
          <li><a (click)="goHome('servicios')">{{ t.nav_servicios }}</a></li>
          <li><a (click)="goHome('trabajos')">{{ t.nav_trabajos }}</a></li>
          <li><a (click)="goMethod()">{{ t.nav_metodologia }}</a></li>
          <li><a (click)="goHome('contacto')">{{ t.nav_contacto }}</a></li>
        </ul>
      </div>
      <div class="footer-col">
        <div class="footer-col-title">{{ t.footer_services }}</div>
        <ul>
          <li><a (click)="ir('robotizacion')">{{ lang === 'ESP' ? 'Robotización' : 'Robotics' }}</a></li>
          <li><a (click)="ir('ecommerce')">E-Commerce</a></li>
          <li><a (click)="ir('desarrollo-web')">Webs & Apps</a></li>
          <li><a (click)="ir('automatizacion')">{{ lang === 'ESP' ? 'Automatización' : 'Automation' }}</a></li>
          <li><a (click)="ir('inteligencia-artificial')">{{ lang === 'ESP' ? 'Inteligencia Artificial' : 'Artificial Intelligence' }}</a></li>
        </ul>
      </div>
    </div>
  </div>
  <div class="footer-bottom">
    <div class="footer-copy">© 2026 Patagonia Chain. {{ t.footer_rights }}</div>
    <div class="footer-sys" aria-hidden="true"><i></i>SYS ▸ ONLINE · PC-01 · 32.95°S 60.65°O</div>
    <div class="footer-social">
      <a href="https://www.instagram.com/patagoniachain/?hl=es" target="_blank" aria-label="Instagram">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <rect x="2" y="2" width="20" height="20" rx="5"/>
          <circle cx="12" cy="12" r="5"/>
          <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
        </svg>
      </a>
      <a href="https://linkedin.com/company/patagonia-chain" target="_blank" aria-label="LinkedIn">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <rect x="2" y="2" width="20" height="20" rx="4"/>
          <path d="M7 10v7M7 7v.01M12 17v-4a2 2 0 014 0v4M12 10v7"/>
        </svg>
      </a>
    </div>
  </div>
</footer>
